import React from 'react';
import {
  TableBody,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { ToolTipElement } from './ToolTipElement';
import { useSelector } from 'react-redux';

const TopTable = ({ tooltipClickHandler }) => {
  const { isMobile, topVolumeData } = useSelector((state) => state.appReducer);
  function createData(name, calls, fat, datq) {
    return { name, calls, fat, datq };
  }
  function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'k' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'G' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
      : '0';
  }
  let rows;
  if (topVolumeData && topVolumeData.length) {
    let A;
    A =
      topVolumeData[0].calls > 1000000
        ? nFormatter(topVolumeData[0].calls, 2)
        : nFormatter(topVolumeData[0].calls, 0);
    let B;
    B =
      topVolumeData[0].avg_total_calls > 1000000
        ? nFormatter(topVolumeData[0].avg_total_calls, 2)
        : nFormatter(topVolumeData[0].avg_total_calls, 0);
    const ratioA = topVolumeData[0].calls / topVolumeData[0].avg_total_calls;
    let C;
    C = nFormatter(topVolumeData[0].puts, 0);
    const D =
      topVolumeData[0].avg_total_puts > 1000000
        ? nFormatter(topVolumeData[0].avg_total_puts, 2)
        : nFormatter(topVolumeData[0].avg_total_puts, 0);
    const ratioB = topVolumeData[0].puts / topVolumeData[0].avg_total_puts;
    const totalVolumeValue = topVolumeData[0].calls + topVolumeData[0].puts;
    const totalVolume =
      totalVolumeValue > 1000000
        ? nFormatter(totalVolumeValue, 2)
        : nFormatter(totalVolumeValue, 0);
    const Volume =
      topVolumeData[0].volume > 1000000
        ? nFormatter(topVolumeData[0].volume, 2)
        : nFormatter(topVolumeData[0].volume, 0);
    const E =
      topVolumeData[0].adv > 1000000
        ? nFormatter(topVolumeData[0].adv, 2)
        : nFormatter(topVolumeData[0].adv, 0);
    const ratioC =
      (topVolumeData[0].calls + topVolumeData[0].puts) / topVolumeData[0].adv;
    const G =
      topVolumeData[0].avg_volume > 1000000
        ? nFormatter(topVolumeData[0].avg_volume, 2)
        : nFormatter(topVolumeData[0].avg_volume, 0);
    const ratioD = topVolumeData[0].volume / topVolumeData[0].avg_volume;
    rows = [
      createData('Call Volume', A, B, ratioA.toFixed(2)),
      createData('Put Volume', C, D, ratioB.toFixed(2)),
      createData('Total Volume', totalVolume, E, ratioC.toFixed(2)),
      createData('Stk Volume', Volume, G, ratioD.toFixed(2)),
    ];
  } else {
    rows = [
      createData('Call Volume', 0, 0, 0),
      createData('Put Volume', 0, 0, 0),
      createData('Total Volume', 0, 0, 0),
      createData('Stk Volume', 0, 0, 0),
    ];
  }

  return (
    <Table style={{ marginTop: '10px' }}>
      <TableHead style={{ borderBottom: '1.2px solid' }}>
        <TableRow>
          <TableCell style={{ padding: '0px' }}>
            <div style={{ marginLeft: '50px' }}>
              <ToolTipElement clickHandler={tooltipClickHandler} />
            </div>
          </TableCell>
          <TableCell
            style={{
              padding: '0px',
              backgroundColor: '#404040',
              color: 'white',
              fontSize: '10px',
              lineHeight: '1.2rem',
              textAlign: 'center',
            }}
          >
            Today
          </TableCell>
          <TableCell
            style={{
              padding: '0px',
              backgroundColor: '#404040',
              color: 'white',
              fontSize: '10px',
              lineHeight: '1.2rem',
              textAlign: 'center',
            }}
          >
            Average
          </TableCell>
          <TableCell
            style={{
              padding: '0px',
              backgroundColor: '#404040',
              color: 'white',
              fontSize: '10px',
              lineHeight: '1.2rem',
              textAlign: 'center',
            }}
          >
            Ratio
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, i) => (
          <TableRow key={i}>
            <TableCell
              style={{
                padding: '0px',
                border: '1.2px solid',
                backgroundColor: '#fffeff',
                width: isMobile ? '80px' : '80px',
                fontSize: '12px',
                textAlign: 'center',
              }}
            >
              {row.name}
            </TableCell>
            <TableCell
              style={{
                padding: '0px',
                border: '1.2px solid',
                backgroundColor: '#f2f2f4',
                fontSize: '12px',
                width: isMobile ? '80px' : '60px',
                textAlign: 'center',
              }}
            >
              {row.calls}
            </TableCell>
            <TableCell
              style={{
                padding: '0px',
                border: '1.2px solid',
                backgroundColor: '#f2f2f4',
                width: isMobile ? '80px' : '60px',
                fontSize: '12px',
                textAlign: 'center',
              }}
            >
              {row.fat}
            </TableCell>

            <TableCell
              style={{
                padding: '0px',
                border: '1.2px solid',
                backgroundColor: '#f2f2f4',
                width: isMobile ? '80px' : '60px',
                fontSize: '12px',
                textAlign: 'center',
              }}
            >
              {row.datq}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
export default TopTable;



// WEBPACK FOOTER //
// ./src/Pages/Stock/topTable.js